module.exports = __webpack_public_path__ + "img/Spain2.845d2d94.png";